// QUERIES
import { brands, productBrand } from 'src/app/queries/brands_query'
import browseCollection from 'src/app/queries/browse_collection_query'
import browseProduct from 'src/app/queries/browse_product_query'
import browseProductRecommendedSize from 'src/app/queries/browse_product_recommended_size_query'
import customerPhotos from 'src/app/queries/customer_photos_query'
import fullProduct from 'src/app/queries/full_product_query'
import {
  freeService,
  freeServiceCancel
} from 'src/app/queries/free_service_query'

import {
  helpRequestConfig,
  helpRequest,
  CreateHelpRequestCustomer
} from 'src/app/queries/help_request'
import {
  singleCollection,
  homeCollections
} from 'src/app/queries/home_collection'
import latestTote from './latest_tote_query'
import creditAccount from 'src/app/queries/credit_account'
import productsWithFilters from 'src/app/queries/products_with_filters_query'

import toteSwapCollections from 'src/app/queries/tote_swap_collections_query.js'
import toteTrackerTotes from 'src/app/queries/tote_tracker_tote_query'
import toteSwapFilteredProducts from 'src/app/queries/tote_swap_filtered_products'
import subscriptionQuery from './subscription_query'
import myClosetQuery from './my_closet'
import promoCodeSelect, {
  fetchPromoCode,
  MUTATION_RECEIVE_SCAN_CODE
} from './promo_code_select'
import totesCheckoutpreview from './tote_checkout_preview'
import {
  onboardingQuestion,
  createOnboardingToteInput,
  createCustomerAttributes
} from './onboarding_v2'
import searchProductContext from './search_product_context'
import toteSwapCollectionProducts from './collections_products'

import subscriptionMigrationPreview, {
  subscriptionMigration
} from './subscription_migration_preview'

// MUTATIONS
import {
  applyTryOnPromoCode,
  applyRentalPromoCode
} from 'src/app/queries/apply_promo_code'
import createCustomerAttributePreferences from 'src/app/queries/create_customer_attribute_preferences'
import createInstantTransaction from 'src/app/queries/create_instant_transaction'
import createPurchaseTote from 'src/app/queries/create_purchase_tote'
import markToteDelivered from 'src/app/queries/deliver_tote_query'
import {
  HomepageBanner,
  HomepageBannerGroup
} from 'src/app/queries/homepage_banner'
import { PURCHASE_FREE_SERVICE } from 'src/app/queries/purchase_free_service'
import updateCustomer from 'src/app/queries/update_customer'
import updateStyle from 'src/app/queries/update_style'
import customer from './current_customer'
import sesameCredit from './sesameCredit'
import updateShippingAddressApi from './update_shipping_address'
import queueProductSizer from './queue_product_sizer'
import createSubscription from './create_subscription'
import updateRatingImage from './update_rating_image'
import updateCustomerProductFilters from './update_customer_productfilters'
import { addToCloset, removeFromCloset } from './update_closet'
import scheduleAutoPickup from './schedule_return_auto_pickup'

import activititesQueries from './activites_query'
import ordersQueries from './orders_query'
import referrerQueries from './referrer_query'

import retryPayment from './retry_payment'
import savePromoCodeToWallet from './save_promo_code_wallet'
import remommandSize from './recommand_size'
import saveReferralCode from './save_referral_code'
import HoldSubscription from 'src/app/queries/hold_subscription'
import { fetchOccasion } from './product_collection'
import { toteProduct } from './tote_product'
import * as operation from './operation'
import enableCustomerContract from './enable_customer_contract'
import disableCustomerContract from './disable_customer_contract'
import SwapToteProduct from './swap_tote_product'
import similarProducts from './similar_product'
import SubmitSwapQuestion from './submit_swap_question'
import { popups, markPopup } from './popups'
import unbindJdCredit from './unbind_jd_credit'
import reactivateSubscription from './reactivate_subscription'
import checkoutToteProducts from './checkout_tote_products'
import scheduleSelfDelivery from './schedule_return_self_delivery'
import successReferrals from './success_referrals'
import {
  QUERY_SUBSCRIPTION_CHANGE_RULES,
  CHANGE_PLAN_BANNER,
  MUTATION_SUBSCRIPTION_CHANGE
} from './change_plans'

import {
  MUTATION_REMOVE_FROM_TOTE_CART,
  MUTATION_ADD_TO_TOTE_CART,
  MUTATION_REPLACE_FOR_TOTE_CART,
  QUERY_TOTE_CART,
  MUTATION_ADD_TOTE_CART_SLOT,
  MUTATION_REMOVE_TOTE_CART_SLOT,
  QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE,
  MUTATION_CANCEL_ORDER,
  QUERY_PLACE_ORDER,
  QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE,
  QUERY_EXPRESS,
  QUERY_EXPRESS_DURATION
} from './tote_cart'
import {
  MUTATION_APPLY_COUPON_TO_TOTE,
  MUTATION_REMOVE_COUPON_FROM_TOTE
} from './tote_cart_coupon'
import {
  queryCustomerPhotoInput,
  queryHomeCustomerPhotos,
  mutationLikeCustomerPhotos,
  mutationDislikeCustomerPhotos,
  queryCustomerPhotosDetailsFirst,
  queryTheRelatedCustomerPhotos,
  queryCustomerPhotosInProduct,
  queryWebCustomerPhotosToteProduct,
  queryMyCustomerPhotos,
  queryMyCustomerPhotoInfo
} from './customer_photos_summary'
import creatCustomerPhotoQuery from './creat_customer_photo'
import { MUTATION_TOTE_CART_CHECKOUT } from './tote_cart_place_order'
import { queryFloathover, mutationFloathover, quiz } from './float_hover_query'
import addPerfectClosets from './add_perfect_closets'
import unreturnToteParts from './unreturn_tote_parts_query'
import checkExpressStatus from './check_express_status_query'
import queryCopywritingAdjustments from './copywriting_adjustments'
import { bustPredict, waistPredict, hipsPredict } from './size_predict_query'
import {
  QUERY_FREE_PURCHASE_TYPE,
  MUTATION_INVITE_TOTE_FREE_PURCHASE
} from './free_purchase'

import totes from 'src/app/queries/totes_query'
import ratings from 'src/app/queries/rating_query'
import plans from './plans_query'
import customerInfomation from './customer_home_query'

export {
  HoldSubscription,
  HomepageBanner,
  HomepageBannerGroup,
  MUTATION_ADD_TOTE_CART_SLOT,
  MUTATION_ADD_TO_TOTE_CART,
  MUTATION_APPLY_COUPON_TO_TOTE,
  MUTATION_CANCEL_ORDER,
  MUTATION_INVITE_TOTE_FREE_PURCHASE,
  MUTATION_REMOVE_COUPON_FROM_TOTE,
  MUTATION_REMOVE_FROM_TOTE_CART,
  MUTATION_REMOVE_TOTE_CART_SLOT,
  MUTATION_REPLACE_FOR_TOTE_CART,
  MUTATION_TOTE_CART_CHECKOUT,
  PURCHASE_FREE_SERVICE,
  QUERY_FREE_PURCHASE_TYPE,
  QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE,
  QUERY_PLACE_ORDER,
  QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE,
  QUERY_EXPRESS,
  QUERY_EXPRESS_DURATION,
  QUERY_TOTE_CART,
  SubmitSwapQuestion,
  SwapToteProduct,
  activititesQueries,
  addPerfectClosets,
  addToCloset,
  applyRentalPromoCode,
  applyTryOnPromoCode,
  brands,
  browseCollection,
  browseProduct,
  browseProductRecommendedSize,
  bustPredict,
  checkExpressStatus,
  checkoutToteProducts,
  creatCustomerPhotoQuery,
  createCustomerAttributePreferences,
  createCustomerAttributes,
  createInstantTransaction,
  createOnboardingToteInput,
  createPurchaseTote,
  createSubscription,
  creditAccount,
  customer,
  customerInfomation,
  customerPhotos,
  disableCustomerContract,
  enableCustomerContract,
  fetchOccasion,
  fetchPromoCode,
  freeService,
  freeServiceCancel,
  helpRequestConfig,
  helpRequest,
  CreateHelpRequestCustomer,
  fullProduct,
  hipsPredict,
  homeCollections,
  latestTote,
  markPopup,
  markToteDelivered,
  mutationDislikeCustomerPhotos,
  mutationFloathover,
  mutationLikeCustomerPhotos,
  myClosetQuery,
  onboardingQuestion,
  operation,
  ordersQueries,
  plans,
  popups,
  productBrand,
  productsWithFilters,
  promoCodeSelect,
  queryCopywritingAdjustments,
  queryCustomerPhotoInput,
  queryCustomerPhotosDetailsFirst,
  queryCustomerPhotosInProduct,
  queryFloathover,
  queryHomeCustomerPhotos,
  queryMyCustomerPhotoInfo,
  queryMyCustomerPhotos,
  queryTheRelatedCustomerPhotos,
  queryWebCustomerPhotosToteProduct,
  queueProductSizer,
  quiz,
  ratings,
  reactivateSubscription,
  referrerQueries,
  remommandSize,
  removeFromCloset,
  retryPayment,
  savePromoCodeToWallet,
  saveReferralCode,
  scheduleAutoPickup,
  scheduleSelfDelivery,
  searchProductContext,
  sesameCredit,
  similarProducts,
  singleCollection,
  subscriptionMigration,
  subscriptionMigrationPreview,
  subscriptionQuery,
  successReferrals,
  toteProduct,
  toteSwapCollectionProducts,
  toteSwapCollections,
  toteSwapFilteredProducts,
  toteTrackerTotes,
  totes,
  totesCheckoutpreview,
  unbindJdCredit,
  unreturnToteParts,
  updateCustomer,
  updateCustomerProductFilters,
  updateRatingImage,
  updateShippingAddressApi,
  updateStyle,
  waistPredict,
  QUERY_SUBSCRIPTION_CHANGE_RULES,
  MUTATION_SUBSCRIPTION_CHANGE,
  CHANGE_PLAN_BANNER,
  MUTATION_RECEIVE_SCAN_CODE
}
